import Header from "./Component/Header";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
} from "react-router-dom";
import Shop from "./Component/Shop";
import Contact_us from "./Component/Contact_us";
import Checkout from "./Component/Checkout";
import Myaccount from "./Component/Myaccount";
import Login from "./Component/Login";
import Single_products from "./Component/Single_products";
import Shops_category from "./Component/Shops_category";
import CardList from "./Component/CardList";
import Favratewishlist from "./Component/Favratewishlist";
import SearchProducts from "./Component/SearchProducts";
import Track_order from "./Component/Track_order";
import Astrologer from "./Component/Astrologer";
import AboutUs from "./Component/Aboutus";
import TermsAndCondition from "./Component/TermsAndCondition";
import PrivacyPolicy from "./Component/PrivacyPolicy";
import RefundPolicy from "./Component/RefundPolicy";
import Faq from "./Component/Faq";
import UserProfile from "./Component/UserProfile";
import Address from "./Component/Address";
import AboutGemstones from "./Component/AboutGemstones";
import Wishlist from "./Component/Wishlist";
import MyOrders from "./Component/MyOrders";
import TrackOrder from "./Component/TrackOrder";
import MenuSection from "./Component/MenuSection";
import Search from "./Component/Search";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Header />}></Route>
          <Route path="/shop" element={<Shop />}></Route>
          <Route path="/shopscategory" element={<Shops_category />}></Route>
          <Route path="/contect_us" element={<Contact_us />}></Route>
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/myaccount" element={<Myaccount />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route
            path="/single_products/:id"
            element={<Single_products />}
          ></Route>
          <Route path="/Favratewishlist" element={<Favratewishlist />}></Route>
          <Route path="/cardlist" element={<CardList />}></Route>
          <Route path="/aboutUs" element={<AboutUs />}></Route>
          <Route path="/aboutGemstones" element={<AboutGemstones />}></Route>
          <Route path="/SearchProducts" element={<SearchProducts />}></Route>
          <Route path="/search" element={<Search />}></Route>
          <Route path="/track_order" element={<Track_order />}></Route>
          <Route path="/astrologer" element={<Astrologer />}></Route>
          <Route
            path="/termsAndCondition"
            element={<TermsAndCondition />}
          ></Route>
          <Route path="/privacyPolicy" element={<PrivacyPolicy />}></Route>
          <Route path="/refundPolicy" element={<RefundPolicy />}></Route>
          <Route path="/faq" element={<Faq />}></Route>

          <Route path="/address" element={<Address />}></Route>

          <Route path="/editProfile" element={<UserProfile />}></Route>

          <Route path="/wishlist" element={<Wishlist />}></Route>
          <Route path="/myOrders" element={<MyOrders />}></Route>
          <Route path="/trackOrder" element={<TrackOrder />}></Route>
          <Route path="/menuSection" element={<MenuSection />}></Route>


        </Routes>
        <div className="bottom-navigation">
          <NavLink to="/" end className="nav-item">
            <i className="las la-home"></i>
            <span>Home</span>
          </NavLink>

          <NavLink to="/astrologer" className="nav-item">
            <i className="las la-user-astronaut"></i>
            <span>Astrologer</span>
          </NavLink>

          <NavLink to="/astrologer" className="nav-item">
            <i className="las la-comment-dots"></i>
            <span>Support</span>
          </NavLink>

          <NavLink to="/myOrders" className="nav-item">
            <i className="las la-shopping-bag"></i>
            <span>My Orders</span>
          </NavLink>

          <NavLink to="/menuSection" className="nav-item">
            <i className="las la-user-circle"></i>
            <span>Profile</span>
          </NavLink>
        </div>
      </Router>
    </>
  );
}

export default App;
